export default "__VITE_ASSET__DrrENvi1__"